import React from 'react';
import { WINDOW_SIZES } from 'src/constants/main';
import { appStore } from 'src/mobx/appStore';
import { cartStore } from 'src/mobx/cartStore';
import { localeStore } from 'src/mobx/localesStore';
import { IProductInsideCombo } from 'src/types/combo';
import { IProduct } from 'src/types/products';
import { getTranslate } from 'src/utils/formatter';
import { getProductUnits } from 'src/utils/product';
import { Carousel } from 'src/view/components/Carousel/Carousel';
import ResponsiveContent from 'src/view/components/ResponsiveContent/ResponsiveContent';
import ComboItem from '../../components/ComboItem/ComboItem';
import ComboCarouselArrow from '../../components/ComboCarouselArrow/ComboCarouselArrow';
import ProductNotes from '../../components/ProductNotes/ProdutcNotes';
import './style.scss';

interface IProps {
  product?: IProduct;
  onNotesChanged: (notes: string) => void;
  onDealChange: (item: IProductInsideCombo) => void;
}

export default class DealComboItemsBlock extends React.Component<IProps> {
  selectItem = (item: IProductInsideCombo) => {
    this.props.onDealChange(item);
  };

  get itemDescripton(): string | undefined {
    if (!this.props.product || !this.props.product.items?.length) return undefined;
    const selectItem: IProductInsideCombo | undefined = this.props.product.items.find((item) => item.is_selected);
    const units = getProductUnits(selectItem);
    const text = [...units, getTranslate(selectItem?.description)].filter(Boolean).join(' • ');
    return text;
  }

  render() {
    const { product } = this.props;
    if (!product?.items?.length) return null;

    const showNotes =
      appStore.settings?.item_notes &&
      (!cartStore.isSMS || (cartStore.isEditable && product?.hash) || product?.notes) &&
      product?.type;

    return (
      <div className="deal-combo-items-block">
        <ResponsiveContent min={WINDOW_SIZES.md}>
          <p className="deal-combo-items-block__header family-bold color-dark">{localeStore.t('combo_products')}</p>
          <Carousel
            itemsToShow={3}
            itemsToScroll={2}
            renderArrow={ComboCarouselArrow}
            className="combo-items__carousel"
            disableArrowsOnEnd={true}
            focusOnSelect={true}
          >
            {product.items.map((item, index) => (
              <ComboItem
                key={item.id}
                index={index}
                item={item}
                selectItem={this.selectItem}
                className="combo-items__item"
                selected={Boolean(item.is_selected)}
              />
            ))}
          </Carousel>
          {this.itemDescripton ? (
            <p className="deal-combo-items-block__item-description family-regular color-dark text-lite-elipsis">
              {this.itemDescripton}
            </p>
          ) : null}
        </ResponsiveContent>

        <ResponsiveContent max={WINDOW_SIZES.md}>
          <ul className="deal-combo-items-block__wrapper d-flex flex-column">
            {product.items.map((item) => (
              <ComboItem key={item.id} item={item} selectItem={this.selectItem} selected={Boolean(item.is_selected)} />
            ))}
          </ul>
          {showNotes ? (
            <ProductNotes
              loading={!product}
              onChange={this.props.onNotesChanged}
              value={product?.notes || ''}
              disabled={!cartStore.isEditable}
            />
          ) : null}
        </ResponsiveContent>
      </div>
    );
  }
}
